import React, { useCallback, useState, useEffect } from 'react';

import { Paper, ButtonBase } from '@mui/material';
import { Add, Close }from '@mui/icons-material';

import TrplSelect from '../../common/TrplControls/TrplSelect';
import Search from '../../common/Search';
import Node from '../../common/Node';
import JelListViewBtn from './components/JelListViewBtn';
import LoaderNew from '../../common/LoaderNew';

import { getJelSelectValues } from '../../utils';
import ArrowTooltipCss from '../../common/ArrowTooltipCss';

export default (
  ({
    jels,
    classes,
    setupRbox,
    deleteJel,
    saveNewDefaultView,
  }) => {
  const [savingDefault, setSavingDefault] = useState(false);
  const [defaultsDeleting, setDefaultDeleting] = useState([]);
  const [openedAddRule, setOpenAddRule] = useState(false);
  const [newDefault, setNewDefault] = useState(null);
  const [selectViewValues, setSelectViewValues] = useState('');

  const changeDefaultNode = useCallback((nodeId) => {
    if (nodeId) setNewDefault({ concept: nodeId });
    else setNewDefault(null);

    setSelectViewValues(nodeId ? getJelSelectValues(jels, nodeId, null, 'forms') : '');
  }, []);

  const changeDefaultView = useCallback((viewId) => {
    setNewDefault((prevState) => {
      return ({ ...prevState, form: viewId });
    });
  }, []);

  return (
    <Paper className={classes.paperContainer}>
      <div className={`${classes.alignCenter} ${classes.mb10}`} style={{ height: '40px' }}>
        <span className={classes.columnHeadingGeneral} style={{ margin: '5px 15px 10px 0' }}>Default forms</span>
        {openedAddRule ? 
          <div className={`${classes.alignEnd}`}>
            <div>
              <span style={{ fontSize: 11, color: '#878787' }}>Select concept</span>
              <div className={classes.mr5}>
                {newDefault && newDefault.concept ?
                  <Node
                    isLink
                    size="sm"
                    isRemovable
                    nodes={setupRbox}
                    nodeId={newDefault.concept}
                    node={setupRbox[newDefault.concept]}
                    onRemoveClick={() => {
                      changeDefaultNode(null);
                    }}
                  />
                :
                  <Search
                    conceptsOnly={true}
                    containerStyles={{
                      height: 24,
                    }}
                    onDropdownElementClick={({ node }) => {
                      changeDefaultNode(node.id);
                    }}
                  />
                }
              </div>
            </div>
            <div className={`${classes.w200}`}>
              <TrplSelect
                margin="none"
                complicatedValues
                placeholder='Select view'
                values={selectViewValues}
                value={newDefault && newDefault.form ? newDefault.form : ''}
                title="On edit node click form"
                onChange={(e) => changeDefaultView(e.target.value)}
              />
            </div>
            <div className={`${classes.ml10}`}>
              <ButtonBase
                disabled={!newDefault || !newDefault.concept || !newDefault.form}
                className={`${classes.btn} ${classes.secondaryBtn}`}
                onClick={() => {
                  setSavingDefault(true);
                  saveNewDefaultView(newDefault, () => {
                    setNewDefault(null);
                    setSavingDefault(false);
                    setOpenAddRule(false);
                  });
                }}
              >
                {savingDefault ? <LoaderNew/> : 'Set default view rule'}
              </ButtonBase>
            </div>
          </div>
        :
          <div>
            <ButtonBase
              className={`${classes.btn} ${classes.secondaryBtn}`}
              onClick={() => setOpenAddRule(true)}
            >
              Add default
              <Add
                style={{
                  fontSize: '13px',
                  marginLeft: '4px',
                  color: '#347CFF',
                }}
              />
            </ButtonBase>
          </div>
        }
      </div>

      <div className={classes.ruby}>
        {jels.defaultForms && jels.defaultForms.length ? jels.defaultForms.map((defaultObj, index) => {
          const view = defaultObj.form ? jels.jelData[defaultObj.form] : null;
          const concept = defaultObj.concept ? setupRbox[defaultObj.concept] : null;
          const defaultIsDeleting = defaultsDeleting.includes(defaultObj.id);

          return (
            <div
              key={index}
              className={`${classes.alignCenter} ${classes.mr10} ${classes.mb10}`}
              style={{
                border: '1px solid #F1F1F6',
                borderRadius: '0 12px 12px 0',
                opacity: defaultIsDeleting ? 0.5 : 1,
                pointerEvents: defaultIsDeleting ? 'none' : ''
              }}
            >
              {concept ?
                <div className={classes.mr5}>
                  <Node isLink size="sm" nodes={setupRbox} nodeId={defaultObj.concept} node={concept} />
                </div>
              : null}

              {view ?
                <JelListViewBtn
                  viewData={{ type: view.type, title: `${view.id} ${view.title}`, id: view.id }}
                  openViewInNewTab={true}
                />
              : null}

              <ArrowTooltipCss text='Delete default setting'>
                <div className={`${classes.alignCenter} ${classes.ml5}`} style={{ width: '24px' }}>
                  {defaultsDeleting.includes(defaultObj.id) ? <LoaderNew style={{ height: '14px' }}/> :
                    <Close
                      className={`${classes.btnIcon}`}
                      style={{ fontSize: 13 }}
                      onClick={() => {
                        const defaultDeleteId = defaultObj.id;
                        setDefaultDeleting((prevState) => [ ...prevState, defaultDeleteId ]);
                        deleteJel(defaultDeleteId, () => {
                          setDefaultDeleting([]);
                        });
                      }}
                    />
                  }
                </div>
              </ArrowTooltipCss>
            </div>
          )
        }) : null}
      </div>

    </Paper>
  )
});
